import { render, staticRenderFns } from "./PropertyMaintenanceItemAddPanel.vue?vue&type=template&id=63b712fc"
import script from "./PropertyMaintenanceItemAddPanel.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceItemAddPanel.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceItemAddPanel.vue?vue&type=style&index=0&id=63b712fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports